import React, { useState } from 'react'
import { isLoaded, useFirebase, firestoreConnect } from 'react-redux-firebase'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  Button,
  Spinner,
  Modal,
  ModalBody,
} from 'reactstrap'
import { Redirect, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
// import Checkbox from '@material-ui/core/Checkbox'

import moment from 'moment'
import 'moment/locale/fi'
import { Divider } from '@material-ui/core'
import PaymentRedirect from '../PaymentRedirect'
import PaymentOptions from '../PaymentOptions'
import { useEffect } from 'react'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { useCookies } from 'react-cookie'
import withAppconfig from '../../AppContext'
import Payments from '../../components/Payments'
import { Grid, Typography } from '@material-ui/core'
import Poster from '../../components/Poster'
import TextField from '@material-ui/core/TextField'

const enhance = compose(
  connect(({ payable: { selected }, globaltime: { gtime } }) => {
    if (selected) {
      // console.log('selected', selected)
      const summary = { price: 0 }
      return {
        selected,
        summary,
        gtime,
      }
    } else {
      return {
        selected,
        summary: {},
        gtime,
      }
    }
  })
)

function EventTicketVariation({ variations, ticketVariantAmounts }) {
  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      {variations.map((v) => {
        if (ticketVariantAmounts[v.id] === 0) {
          return null
        }
        return (
          <React.Fragment key={v.id + '-fragment'}>
            <Grid item xs={5} key={v.id + '-name'}>
              <Typography
                variant='h6'
                component='span'
                style={{ marginRight: 10 }}
              >
                {v.name}
              </Typography>
            </Grid>
            <Grid item xs={3} key={v.id + '-price'}>
              <Typography
                variant='body1'
                component='span'
                style={{ marginRight: 10 }}
              >
                {ticketVariantAmounts[v.id] > 0
                  ? `${ticketVariantAmounts[v.id]} kpl`
                  : ''}{' '}
                {`(${(v.price / 100).toFixed(2).replace('.', ',')} €/kpl)`}
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              key={`input-${v.id}`}
              style={{ textAlign: 'right' }}
            >
              {ticketVariantAmounts[v.id] > 0
                ? `${((v.price * ticketVariantAmounts[v.id]) / 100)
                    .toFixed(2)
                    .replace('.', ',')} €`
                : ''}
            </Grid>
            <Grid item xs={12} key={`divider-${v.id}`}>
              <Typography variant='caption' style={{ color: '#888' }}>
                {v.description || 'Ei lisätietoja'}
              </Typography>
              <Divider style={{ margin: '10px 0' }} />
            </Grid>
          </React.Fragment>
        )
      })}
    </Grid>
  )
}

const UNALLOWED_METHODS = [
  'cashier',
  'cashstore',
  'minutestore',
  'cashwallet',
  'benefitcard',
]

const GiftPaymentScreen = ({ selected, dispatch, appconfig }) => {
  const firebase = useFirebase()
  let history = useHistory()
  let defaultLanguage = 'FI'
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [renderPayments, setRenderPayments] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(null)
  // const [payments, setPayments] = useState(null)
  const [errorNotification, setErrorNotification] = useState(null)
  const [onlinepaymentprovider, setOnlinePaymentProvider] = useState(null)
  const [initdone, setInitDone] = useState(false)
  // const [usernote, setUserNote] = useState(null)
  // const [membershipprices, setMembershipPrices] = useState(null)
  // const [giftcoderedeem, setGiftcoderedeem] = useState(null)
  // const [pricescheck, setPricesCheck] = useState(false)
  const [emailToSendGift, setEmailToSendGift] = useState(null)
  const [allInfoAdded, setAllInfoAdded] = useState(false)
  // console.log('selected', selected)

  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['selectedLanguage'])
  if (cookies.selectedLanguage) {
    defaultLanguage = cookies.selectedLanguage
  }
  // console.log('saldo', saldo, isLoaded(saldo))

  useEffect(() => {
    if (emailToSendGift && verifyEmail(emailToSendGift)) {
      setAllInfoAdded(true)
    } else {
      setAllInfoAdded(false)
    }
  }, [emailToSendGift])

  useEffect(() => {
    moment.locale(defaultLanguage.toLowerCase(), { week: { dow: 3 } })
  }, [defaultLanguage])
  const loaded = isLoaded(selected)

  if (loaded && !initdone) {
    setInitDone(true)
  }

  const goGifts = () => {
    dispatch({
      type: 'CLEAR_PAYABLE_GIFTCARD',
      payload: null,
    })
    history.push(appconfig.pathPrefix + '/shop/gifts')
  }

  const setPaymentProvider = (p) => setOnlinePaymentProvider(p)

  const verifyEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  const payGift = async (selectedPayments) => {
    setLoading(true)
    const payableObject = {
      id: selected.id,
      customerid: appconfig.accountkey,
      paymentmethod: selectedPayments,
      variation: selected.selectedVariant,
      type: 'giftcard',
      emailToSendGift: emailToSendGift,
    }
    console.log('payableObject', payableObject)

    // if (giftcoderedeem) {
    //   payableObject.giftcode = giftcoderedeem
    // }

    const shouldRenderOptions =
      selected.sumprice > 0
        ? selectedPayments.find((x) => x.type === 'online' && x.charged > 0)
        : false
    const shouldRedict =
      selected.sumprice > 0
        ? selectedPayments.find((x) => x.type === 'online' && x.charged > 0)
        : false
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'gifts-pay' : 'gifts-pay'
    const giftPayment = firebase.functions().httpsCallable(fn)
    try {
      let response = await giftPayment(payableObject)
      console.log('response', response)
      if (response.data.error || response.data.status === 'ERROR') {
        setLoading(false)
        const message = response.data.error || response.data.message
        setErrorNotification(message)
      } else if (shouldRenderOptions) {
        setRenderPayments(true)
      } else if (shouldRedict) {
        setRedirect(true)
      } else {
        setLoading(false)
        history.push(appconfig.pathPrefix + '/shop/gifts')
      }
    } catch (error) {
      alert(error.message)
      // console.log(error)
      setLoading(false)
    }
  }

  // const getNoteRow = () => {
  //   if (appconfig.activityextrafields) {
  //     return (
  //       <React.Fragment>
  //         <Divider />
  //         <Row className={'loose'}>
  //           <Col>
  //             <FormGroup className='loose-form'>
  //               <Label for='usernote'>{t('additionalinfo')}</Label>
  //               <Input
  //                 type='text'
  //                 name='usernote'
  //                 id='usernote'
  //                 value={usernote || ''}
  //                 placeholder=''
  //                 onChange={(event) => setUserNote(event.target.value)}
  //               />
  //             </FormGroup>
  //           </Col>
  //         </Row>
  //       </React.Fragment>
  //     )
  //   } else {
  //     return null
  //   }
  // }

  // const updateItemPricing = (prices) => {
  //   if (prices && prices.length > 0) {
  //     prices.sort((a, b) => a.price - b.price)
  //   }
  //   let membershipids = memberships.map((v) => v.membershipid) //Object.keys(memberships || {}).map((key) => {
  //   //   return memberships[key].membershipid
  //   // })
  //   let _membershipprices = prices.filter((x) => {
  //     if (x.membershipid) {
  //       return membershipids.includes(x.membershipid)
  //     } else {
  //       return true
  //     }
  //   })
  //   // console.log('membershipprices', _membershipprices, 'selected', { ...selected })
  //   const originalPrice = selected.price
  //   if (_membershipprices && _membershipprices.length > 0) {
  //     selected.price = _membershipprices[0].price
  //   }
  //   if (_membershipprices.length > 0) {
  //     selected.overridecost = true
  //     const gen = {
  //       pricing: 'general',
  //       price: originalPrice,
  //     }
  //     _membershipprices.push(gen)
  //     // membershipprices.find((x) => x.pricing === 'general')
  //     // selected.general = gen
  //   }
  //   setMembershipPrices(_membershipprices)
  // }

  // const onValidGiftcode = (membershipprices, giftcode) => {
  //   setGiftcoderedeem(giftcode)
  //   updateItemPricing(membershipprices)
  // }

  const cancelEntry = async (id) => {}

  if (!selected) {
    return <Redirect to='/' />
  }

  if (renderPayments) {
    return (
      <PaymentOptions
        selectedGw={'pc'}
        authorization={token}
        provider={onlinepaymentprovider}
        disabledmethods={appconfig.disabledpaymentmethods || []}
        onCancel={cancelEntry}
        cancellable={{ id: selected.id, type: 'giftcards' }}
      />
    )
  } else if (redirect) {
    return <PaymentRedirect selectedGw={'pc'} authorization={token} />
  }

  if (!loaded) {
    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Spinner /> Loading ...
        </Container>
      </div>
    )
  } else {
    // let lastvalidDate = getLastvalidDate(selected.validity, gtime)
    // if (lastvalidDate === 'permanent') {
    //   lastvalidDate = t('permanent')
    // } else {
    //   lastvalidDate = lastvalidDate.format('D.M.YYYY')
    // }

    if (
      !selected.ticketVariantAmounts ||
      Object.keys(selected.ticketVariantAmounts).length === 0
    ) {
      selected.ticketVariantAmounts = {}
    }
    if (selected.sumprice === undefined) {
      selected.sumprice = Object.keys(selected.ticketVariantAmounts).reduce(
        (acc, curr) => {
          const variant = selected.variations.find((v) => v.id === curr)
          if (!variant) {
            console.warn(
              `Variant with id ${curr} not found in selected variations`
            )
            return acc
          }
          acc += selected.ticketVariantAmounts[curr] * variant.price
          return acc
        },
        0
      )
    }

    let unallowedmethods = UNALLOWED_METHODS
    // if (appconfig && appconfig.experimental && appconfig.experimental.paycardsfromsaldo) {
    //   unallowedmethods = ['cashier', 'cashstore', 'minutestore', 'benefitcard']
    // }

    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Row>
            <Col md='8' className='mx-auto'>
              <Card>
                <CardHeader tag='h4'>{t('payment')}</CardHeader>
                <CardBody>
                  <CardTitle tag='h5'>
                    {selected.displayName}{' '}
                    {'- ' + selected.selectedVariant.name}
                  </CardTitle>
                  <Row className={'loose'}>
                    <Col className={'text-right'}>
                      <Poster
                        data={selected.poster}
                        preferredSize={300}
                        alt={selected.displayName}
                        defaultBg={appconfig.logos}
                        // style={{ width: '100%' }}
                      />
                    </Col>
                  </Row>
                  <Divider style={{ marginTop: 10 }} />
                  <Row className={'loose'} key={'price'}>
                    <Col>{t('price')}</Col>
                    <Col className={'text-right'}>
                      {(selected.selectedVariant.price / 100)
                        .toFixed(2)
                        .replace('.', ',')}{' '}
                      €
                    </Col>
                  </Row>
                  <Row className={'loose'} key={'email'}>
                    <Col xs={12}>
                      <TextField
                        type='email'
                        name='emailToSendGift'
                        id='emailToSendGift'
                        label={t('email')}
                        value={emailToSendGift || ''}
                        placeholder={t('email')}
                        onChange={(event) =>
                          setEmailToSendGift(event.target.value)
                        }
                        fullWidth
                        required
                        error={
                          emailToSendGift
                            ? !verifyEmail(emailToSendGift)
                            : false
                        }
                      />
                    </Col>
                    <Col xs={12}>
                      <Divider />
                      <Typography variant='body1' style={{ marginTop: 25, marginBottom: 25 }}>
                        {t('giftcard_guidance')}
                      </Typography>
                    </Col>
                  </Row>

                  <Divider />
                  <CardText></CardText>
                  <Payments
                    benefitPurchase={{ collection: 'gifts', customerid: appconfig.accountkey }}
                    onlyfullpayment={true}
                    price={selected.selectedVariant.price / 100}
                    selecttype='payable'
                    unallowedmethods={unallowedmethods}
                    buttonText={
                      selected?.selectedVariant?.price > 0
                        ? t('pay')
                        : t('confirm')
                    }
                    buttonAction={payGift}
                    errorNotification={errorNotification}
                    setPaymentProvider={setPaymentProvider}
                    ready={allInfoAdded}
                    nooverridemetohods={unallowedmethods}
                    anonymous={true}
                  />
                  <Button
                    size='small'
                    color='link'
                    className='text-muted'
                    onClick={() => goGifts()}
                  >
                    <ChevronLeftIcon /> {t('back_to_giftcards')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size='sm'
          centered
          isOpen={loading}
          backdrop={true}
          wrapClassName={'al-wrap'}
          modalClassName={'al-modal'}
          contentClassName={'loading-spinner'}
        >
          <ModalBody className='text-center'>
            <Spinner color='light' />{' '}
            <p style={{ color: 'white' }}>Vahvistetaan</p>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default withAppconfig(enhance(GiftPaymentScreen))
